// extracted by mini-css-extract-plugin
export var table = "_vb-0";